import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createContext, useState } from 'react';
import { pentairDarkTheme, pentairTheme } from '../theme/theme';
import { CountriesProvider } from './countries';
const PentairContext = createContext(null);
export const PentairApp = ({ children, countries, ...props }) => {
    const [theme, setTheme] = useState(props.theme || 'light');
    const muiTheme = theme === 'dark' ? pentairDarkTheme : pentairTheme;
    return (_jsx(PentairContext.Provider, { value: {
            theme,
            setTheme,
        }, children: _jsxs(ThemeProvider, { theme: muiTheme, children: [_jsx(CssBaseline, {}), _jsx(CountriesProvider, { ...countries, children: children })] }) }));
};
